<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="编辑"
      class="customer-edit"
      width="800px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="materials"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="物料编号">
            <el-input v-model="materials.no" placeholder="请输入" disabled="disabled"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料描述">
            <el-input v-model="materials.name" placeholder="请输入" disabled="disabled"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="英文描述">
            <el-input v-model="materials.englishName" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工时">
            <el-input v-model="materials.productionTime" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="最高库存">
            <el-input v-model="materials.maxStock" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最低库存">
            <el-input v-model="materials.minStock" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="主产线">
            <el-select v-model="materials.mainProductionLine" clearable placeholder="请选择">
              <el-option
                  v-for="item in productionLines"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="辅线">
            <el-select v-model="materials.viceProductionLine" clearable placeholder="请选择">
              <el-option
                  v-for="item in productionLines"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="采购类型">
            <el-select v-model="materials.purchaseType" clearable placeholder="请选择">
              <el-option
                  v-for="item in purchaseTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import constant from "../../../util/constant";

  export default {
    name:"MaterialEdit",
    components: {},
    data() {
      return {
        constant,
        productionLines: constant.toSelect(constant.productionLine),
        purchaseTypes: constant.toSelect(constant.purchaseType),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        materials: {
          id: "",
          no: "",
          name: "",
          englishName: "",
          productionTime: "",
          maxStock: "",
          minStock: "",
          mainProductionLine: "",
          viceProductionLine: "",
          mainLines: [],
          viceLines: [],
          purchaseType: 10,
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.materials.id = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `baseMaterials/${this.materials.id}`)
          .then(resp => {
            resp.purchaseType = resp.purchaseType == null ? 10 : resp.purchaseType;
            this.materials = resp;
          });
      },
      handleSubmit() {
        if(this.materials.mainProductionLine ===this.materials.viceProductionLine) {
          this.$message.error("主线和辅线不能一样");
        }else {
          this.$refs.form.validate(valid => {
            if (valid) {
              this.submitLoading = true;
              this.$http
                .save("basic", "baseMaterials", this.materials)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
